import { useQuery } from '@tanstack/react-query';
import { appUrls } from 'constants/urls';
import axiosInstance from 'utils/axiosInstance';
import { queryKeys } from 'react-query/constant';

const GetAppType = () => {
  return async () => {
    const response = await axiosInstance.get(appUrls.appType);
    return response.data;
  };
};

export const useAppType = () => {
  const fetchData = GetAppType();
  return useQuery([queryKeys.appType], () => fetchData());
};
